<template>
    <div class="superPrice" :class="classSuperPrice">
        <div v-if="titleText && title" class="superPrice__title">
            {{ titleText }}
            <Popper v-if="competitorPricesConcurent.length > 0" hover arrow placement="bottom" class="superPrice__popper">
                <i class="ico ico--info"></i>{{ competitorPricesConcurent }}
                <template #content>
                    <div class="superPrice__popper__content">
                        <div v-for="(item, index) in competitorPricesConcurent" :key="index" class="row">
                            <div class="col-6 text-left">{{ item.competitorName }}</div>
                            <div class="col-6 fwb text-right">{{ $formatCurrency(item.price) }}</div>
                        </div>
                    </div>
                </template>
            </Popper>
        </div>
        <div v-else-if="title" class="superPrice__title">
            {{ $t('productDetail.superPrice').toUpperCase() }}
        </div>
        <div class="superPrice__content" :class="{ 'superPrice__content--default': title }">
            <div v-if="priceBefore" class="superPrice__old" :class="{ 'superPrice__old--catalog': !title }">
                <s class="superPrice__old__price" v-html="$formatCurrency(priceBefore)" />
            </div>
            <div class="superPrice__new" v-html="$formatCurrency(priceActual)" />
        </div>
    </div>
</template>

<script setup lang="ts">
// @ts-ignore
import Popper from 'vue3-popper'
import { PropType } from 'vue'

const props = defineProps({
    priceBefore: {
        type: Number,
        required: false,
        default: 0,
    },
    priceActual: {
        type: Number,
        required: true,
    },
    title: {
        type: Boolean,
        default: true,
    },
    titleText: {
        type: String,
        default: null,
    },
    grayscale: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String,
        default: 'default',
    },
    competitorPricesConcurent: {
        type: Array as PropType<{ competitorName: string; price: number }[]>,
        default: () => [],
    },
})

const { grayscale, title, size } = toRefs(props)

const classSuperPrice = [
    grayscale.value && 'superPrice--grayscale',
    title.value && 'superPrice--detail',
    size.value && `superPrice--${size.value}`,
]
</script>

<style lang="scss" scoped>
@import '../../node_modules/bootstrap/scss/functions';
@import '../../node_modules/bootstrap/scss/variables';
@import '../../node_modules/bootstrap/scss/mixins';

.superPrice {
    display: inline-block;
    border-radius: 5px;
    overflow: hidden;
    margin: 0 auto;

    @media (max-width: 768px) {
        margin: 0 auto;
        min-width: 120px;
    }

    &__popper {
        .ico {
            filter: grayscale(1);
        }
    }
    &__popper__content {
        min-width: 200px;
        font-weight: normal;
        line-height: 32px;
        padding: 13px;
    }

    &--detail {
        @media (min-width: 480px) {
            margin-bottom: 0.75rem;
            margin-top: 0.3rem;
        }
    }

    &--grayscale {
        .superPrice__title {
            background: #e1e1e1;
        }

        .superPrice__content {
            background: #f6f6f6;
            color: #333333;
        }
    }

    &--xl {
        .superPrice__title {
            font-size: 14px;
            padding: 0.5rem 1rem;

            @media (max-width: 768px) {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 49px;
                padding: 0;
            }
        }
        .superPrice__new {
            font-size: 24px;
            padding: 1rem;
            @media (min-width: 768px) {
                min-width: 250px;
            }
        }
    }
}

.superPrice__title {
    background-color: $color-gold;
    color: $color-dark;
    font-weight: 700;
    font-size: 12px;
    padding: 0.25rem 0.5rem;
    text-align: center;
}

.superPrice__content {
    background-color: $color-cta;
    color: $color-white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        width: 100%;
    }

    &--default {
        @media (min-width: 768px) {
            display: block;
            text-align: center;
        }
    }
}

.superPrice__old {
    padding-left: 0.5rem;
    font-weight: normal;

    @media (min-width: 768px) {
        padding: 0 0.5rem;
    }

    &--catalog {
        padding-right: 0;
    }
}

.superPrice__new {
    font-weight: bold;
    padding: 0.25rem 0.5rem;
    font-size: 14px;
    margin: 0 auto;

    @include media-breakpoint-up(md) {
        font-size: 16px;
    }
}
</style>
